import { tokens as currencyChipTokens } from '@pkg/components/CurrencyChip/CurrencyChip.tokens';
import { tokens as fieldTextTokens } from '@pkg/components/forms/FieldText/FieldText.tokens';

const formGroupGap = 10;
const prefixSize = 14;
const suffixSpaceAfter = (fieldTextTokens.height.small - currencyChipTokens.height) / 2;
const currencyChipLength = 4;

export const tokens = {
    gap: formGroupGap,
    control: {
        lastChild: {
            minWidth: 120,
        },
    },
    prefix: {
        size: prefixSize,
        offset: formGroupGap / 2 + prefixSize,
    },
    suffix: {
        spaceAfter: suffixSpaceAfter,
        maxLength: currencyChipLength,
        offset:
            (currencyChipLength * currencyChipTokens.labelSize) / 2 +
            currencyChipTokens.padding * 2 +
            currencyChipTokens.symbolSize +
            suffixSpaceAfter,
    },
};
